import Link from "@mui/material/Link";

export default Link;
